import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'search'
})
export class SearchPipe implements PipeTransform {
  // searchText;
  // searchFullArray(keyArray,item) {
  //   var _this = this;
  //   return keyArray.some((keyName) => {
  //     if(typeof item[keyName] == 'object' && item[keyName] != null){
  //       var filterKey = Object.keys(item[keyName]);  
  //       return _this.searchFullArray(filterKey,item[keyName])
  //     } else {
  //       if(item[keyName] != null){
  //         return new RegExp(_this.searchText, 'gi').test(item[keyName]) || _this.searchText === "";
  //       } else {
  //         return false;
  //       }
  //     }
  //   })
  // }

  transform(value: any, args?: any, AllowedKey?:Array<string>): any {
    if (!value) return null;
    if (!args) return value;
    args = args.toLowerCase();
    
    return value.filter(function (item) {
      // if(!AllowedKey){
      //   var newitem = item;
      // } else {
      //   var newitem = JSON.parse(JSON.stringify(item, AllowedKey));
      
      // } ///\"[a-zA-Z0-9\W_]+?\":/g
      // var filterKey = Object.keys(newitem);
      // return _this.searchFullArray(filterKey,newitem) 
     if(!AllowedKey){
        var newitem = JSON.stringify(item).replace(/"([^\\"]|\\")*":/g, ' ').replace(/null/g, ' ');
      } else {
        var newitem = JSON.stringify(item, AllowedKey).replace(/"([^\\"]|\\")*":/g, ' ').replace(/null/g, ' ');
      }
      return newitem.toLowerCase().includes(args);
    });
  }
}
